define((require) => {
    "use strict";

    const {isBlank} = require("shared/util/StringUtils");

    return {

        /**
         * Checks whether the given (mongoDB) id is considered valid.
         *
         * @param  {String}  id The hexadecimal string representing the id
         * @return {Boolean}    <tt>true</tt> if the id is vald, <tt>false</tt> otherwise.
         */
        isValid(id) {
            return isBlank(id) || /^[0-9a-f]{24}$/.test(id);
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/util/IdValidator.js